/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_MessageInputs */



/**
* | output |
* | --- |
* | "Status Message" |
*
* @param {Status_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const status_message = /** @type {((inputs?: Status_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Message d’état")
	if (locale === "de") return /** @type {LocalizedString} */ ("Statusmeldung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Messaggio di stato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сообщение о состоянии")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mensaje de estado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("状态消息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ステータスメッセージ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति संदेश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mensagem de status")
	return /** @type {LocalizedString} */ ("Status Message")
});